var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.preview && _vm.cmsIsEnabled)?_c('AdminContentText',{attrs:{"content":_vm.content,"params":_vm.params}}):_c(_vm.tag,{tag:"component",domProps:{"innerHTML":_vm._s(_vm.processedContent)},on:{"click":_vm.onClick}})
}
var staticRenderFns = []

export { render, staticRenderFns }